import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UUID } from 'angular2-uuid';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../../providers/user.service';
import { UserCreateComponent } from '../user-create/user-create.component';

@Component({
  selector: 'app-voip-create',
  templateUrl: '../../shared/base-form/base-form.component.html',
  styleUrls: ['./voip-create.component.scss']
})
export class VoipCreateComponent extends UserCreateComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: UserService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.subentityName = 'voip';
  }

}
